module.exports = __webpack_public_path__ + "img/ematica.f3bb199f.svg";